import dayjs from 'dayjs';

export default {
  name: 'WDateTimeDisplay',
  props: {
    dateTime: {
      required: true,
      type: Object,
    },
    hideStartDate: {
      default: false,
      type: Boolean,
    },
    textClass: {
      default: 'text-sm',
      type: String,
    },
  },
  methods: {
    dayjs,
    inSameDay() {
      const { end_time: end = '', start_time: start = '' } = this.dateTime || {};
      const dayEnd = dayjs(end);
      const dayStart = dayjs(start);

      return dayStart.isSame(dayEnd, 'day');
    },
  },
};
